import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {AddUsersToTicketURL, CSLUsersURL, VerifyUserUrl,BaseUrl, changePasswordURL, termsAndConditionsURL} from "../config/api";
import axios from "axios";
import { fetchTicketDetailsById } from "./ticketListSlice";
import { getUserFriendlyError } from "@common/errorHandler";

interface User {
    userId: number;
    organizationID: null;
    zendeskSupportGroupId: number;
    zendeskSupportGroup: string;
    zendeskUserId: number;
    securityGroupId: number;
    firstName: string;
    lastName: string;
    emailID: string;
    isOnCallStatus: boolean;
    userTypeId: number;
    userType: string;
    isActive: boolean;
    createdBy: number;
    createdDate: string;
    updatedBy: null;
    updatedDate: null;
    message: null;
    success: null;
}

interface OrgUser {
    userId: number;
    hospitalId: string;
    zendeskSupportGroupId: number;
    zendeskSupportGroup: null;
    zendeskUserId: number;
    zendeskOrgId: null;
    securityGroupId: number;
    securityGroupName: null;
    firstName: string;
    lastName: string;
    emailID: string;
    countryCode: null;
    contactNumber: null;
    isOnCallStatus: boolean;
    userTypeId: number;
    userType: null;
    isActive: boolean;
    deactivationReson: null;
    createdBy: number;
    createdDate: string;
    updatedBy: null;
    updatedDate: null;
    totalCount: null;
}

interface TermsAndCondition {
    id:number,
    name:string,
    content:string,
    isActive:boolean,
    version:string,
}

interface UserState {
    user: any;
    securityGroup: string;
    policies: any[];
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    allUsers: User[];
    allUsersLoading: boolean;
    allUsersError: string | null;
    orgUsers: OrgUser[];
    orgUsersLoading: boolean;
    orgUsersError: string | null;
    hospitalName: string;
    hospitalId: string;
    zendeskOrgId: number | null;
    locationId: string;
    city: string;
    addressLine1: string;
    addressLine2: string | null;
    suite: string | null;
    block: string | null;
    state: string;
    zipcode: string;
    countryCode: string;
    countryName: string;
    updateTermsAndConditionsloading: boolean;
    termsAndConditionsError:undefined;
    termsAndConditionsloading:boolean;
    termsAndConditions:TermsAndCondition[];
    termAndConditionError:undefined;
}

const initialState: UserState = {
    user: null,
    securityGroup: "",
    policies: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    allUsers: [],
    allUsersLoading: false,
    allUsersError: null,
    orgUsers: [],
    orgUsersLoading: false,
    orgUsersError: null,
    hospitalName: "",
    hospitalId: "",
    zendeskOrgId: null,
    locationId: "",
    city: "",
    addressLine1: "",
    addressLine2: null,
    suite: null,
    block: null,
    state: "",
    zipcode: "",
    countryCode: "",
    countryName: "",
    updateTermsAndConditionsloading: true,
    termsAndConditionsError:undefined,
    termsAndConditionsloading:true,
    termsAndConditions: [],
    termAndConditionError: undefined,
    
};

export const verifyUser = createAsyncThunk("user/verifyUser", async (_, {rejectWithValue }) => {
    try {
        const response = await axios.get(VerifyUserUrl);
        return response.data;
    } catch (error) {
        console.error("Error verifying user:", error);
        return rejectWithValue(getUserFriendlyError(error));
    }
});

export const fetchAllUsers = createAsyncThunk(
    "user/fetchAllUsers",
    async (_, {rejectWithValue }) => {
        try {
            const response = await axios.get(CSLUsersURL);
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);

export const addUsersToTicket = createAsyncThunk(
    "user/addUsersToTicket",
    async ({ticketId, userIds}: { ticketId: number; userIds: {action:string, userId:number}[] }, {rejectWithValue }) => {
        try {
            const payload = {
                users: userIds
            };

            const response = await axios.put(
                AddUsersToTicketURL(ticketId),
                payload
            );
            return response.data;
        } catch (error: any) {
            console.error("Error adding users to ticket:", error);
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);

export const fetchChangePasswordUrl = createAsyncThunk(
    "changePasswordurl/fetchChangePasswordUrl",
    async (_, {rejectWithValue }) => {
        try {
            const response = await axios.post(changePasswordURL);
            if (response?.data) {
                const resetUrl = new URL(response.data);
                resetUrl.searchParams.set("redirect_uri", `${window.location.origin}/logout}`);
                window.open(resetUrl.toString(), "_self");
            } else {
                throw new Error(response.data.message ?? "Failed to fetch Change Password Url");
            }
        } catch (error: any) {
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);

export const updateTermsAndConditions = createAsyncThunk(
    "updateTermsAndConditions",
    async (payload: {isTermsAndConditionsAccepted: boolean, termsAndConditionsAcceptedVersion: string}, { rejectWithValue }) => {
      try {
        const response = await axios.put(termsAndConditionsURL, payload);
        console.log("response123", response);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(
            response.data.message ?? "Failed to accept terms and conditions"
          );
        }
      } catch (error: any) {
        return rejectWithValue(getUserFriendlyError(error));
      }
    }
  );

  export const fetchTermsAndConditions = createAsyncThunk(
    "fetchTermsAndConditions",
    async (_, {rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/termsandcondition`);
            if (response?.data) {
              console.log("response1234", response);
              return response?.data?.data;
            } else {
                throw new Error(response.data.message ?? "Failed to fetch terms and conditions");
            }
        } catch (error: any) {
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);

interface GetUsersOfOrgParams {
    organizationId: string | number;
    page?: number;
    pageSize?: number;
    ticketId?:number;
}
export const getUsersOfOrg = createAsyncThunk<OrgUser[], GetUsersOfOrgParams>(
    "user/getUsersOfOrg",
    async ({ ticketId, organizationId, page = 1, pageSize = 100 }, { rejectWithValue,dispatch }) => {
        try {
            const url = `${BaseUrl}/api/user/${organizationId}/csl?Page=${page}&PageSize=${pageSize}`;
            const response = await axios.get(url);
              if(response.status===200){
                    dispatch(fetchTicketDetailsById({id:ticketId}))
                }
            const users = response.data.data[0]?.users;
            if (response?.data?.success && Array.isArray(users)) {
                return users as OrgUser[];
            } else {
                console.error("Unexpected API response structure:", response.data);
                return [];
   }
        } catch (error: any) {
            console.error("Error fetching users for organization:", error);
            return rejectWithValue(getUserFriendlyError(error));
        }
    }
);


const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
        },
        resetOrgUsers: (state) => {
            state.orgUsers = [];
            state.orgUsersLoading = false;
            state.orgUsersError = null;
        },
        resetTermsAndConditionState: (state) => {
            state.updateTermsAndConditionsloading=true;
            state.termsAndConditionsError=undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(verifyUser.pending, (state) => {
                state.isLoading = true;
                state.isSuccess = false;
                state.isError = false;
                state.user = null;
                state.securityGroup = "";
                state.policies = [];
                state.hospitalName = "";
                state.hospitalId = "";
                state.zendeskOrgId = null;
                state.locationId = "";
                state.city = "";
                state.addressLine1 = "";
                state.addressLine2 = null;
                state.suite = null;
                state.block = null;
                state.state = "";
                state.zipcode = "";
                state.countryCode = "";
                state.countryName = "";
            })
            .addCase(verifyUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.user = action.payload.user;
                state.securityGroup = action.payload.securityGroup;
                state.policies = action.payload.policies;
                state.hospitalName = action.payload.hospitalName;
                state.hospitalId = action.payload.hospitalId;
                state.zendeskOrgId = action.payload.zendeskOrgId;
                state.locationId = action.payload.locationId;
                state.city = action.payload.city;
                state.addressLine1 = action.payload.addressLine1;
                state.addressLine2 = action.payload.addressLine2;
                state.suite = action.payload.suite;
                state.block = action.payload.block;
                state.state = action.payload.state;
                state.zipcode = action.payload.zipcode;
                state.countryCode = action.payload.countryCode;
                state.countryName = action.payload.countryName;
            })
            .addCase(verifyUser.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.user = null;
                state.securityGroup = "";
                state.policies = [];
                state.hospitalName = "";
                state.hospitalId = "";
                state.zendeskOrgId = null;
                state.locationId = "";
                state.city = "";
                state.addressLine1 = "";
                state.addressLine2 = null;
                state.suite = null;
                state.block = null;
                state.state = "";
                state.zipcode = "";
                state.countryCode = "";
                state.countryName = "";
            })
            .addCase(fetchAllUsers.pending, (state) => {
                state.allUsersLoading = true;
                state.allUsersError = null;
            })
            .addCase(
                fetchAllUsers.fulfilled,
                (state, action: PayloadAction<User[]>) => {
                    state.allUsersLoading = false;
                    state.allUsers = action.payload;
                }
            )
            .addCase(fetchAllUsers.rejected, (state, action) => {
                state.allUsersLoading = false;
                state.allUsersError = action.error.message ?? "Failed to fetch users";
            })
            .addCase(addUsersToTicket.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(addUsersToTicket.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })
            .addCase(addUsersToTicket.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                console.error("Add user to ticket rejected", action.error.message);
            })
             .addCase(getUsersOfOrg.pending, (state) => {
                state.orgUsersLoading = true;
                state.orgUsersError = null;
            })
            .addCase(
                getUsersOfOrg.fulfilled,
                (state, action: PayloadAction<OrgUser[]>) => {
                    state.orgUsersLoading = false;
                    state.orgUsers = action.payload;
                }
            )
            .addCase(getUsersOfOrg.rejected, (state, action) => {
                state.orgUsersLoading = false;
                state.orgUsersError = action.payload as string || "Failed to fetch organization users";
            })
              .addCase(updateTermsAndConditions.pending, (state) => {
                    state.updateTermsAndConditionsloading = true;
                    state.termsAndConditionsError = undefined;
                  })
                  .addCase(updateTermsAndConditions.fulfilled, (state) => {
                    state.updateTermsAndConditionsloading = false;
                  })
                  .addCase(updateTermsAndConditions.rejected, (state, action) => {
                    state.updateTermsAndConditionsloading = false;
                    state.termsAndConditionsError = action.payload as undefined;
                  })
                  .addCase(fetchTermsAndConditions.pending, (state) => {
                    state.termsAndConditionsloading = true;
                    state.termsAndConditionsError = undefined;
                  })
                  .addCase(fetchTermsAndConditions.fulfilled, (state, action) => {
                    state.termsAndConditionsloading = false;
                    state.termsAndConditions=action.payload;
                  })
                  .addCase(fetchTermsAndConditions.rejected, (state, action) => {
                    state.termsAndConditionsloading = false;
                    state.termAndConditionError = action.payload as undefined;
                  })
    },
});

export const { reset, resetOrgUsers, resetTermsAndConditionState } = userSlice.actions;
export default userSlice.reducer;